"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
/** @deprecated Use overflow, text-overflow and white-space: nowrap */
var truncate = function (options) { return function (value) {
    var e_1, _a;
    var _b = __assign({ length: 30, omission: '...', separator: ' ' }, options), length = _b.length, omission = _b.omission, separator = _b.separator;
    if (value.length <= length) {
        return value;
    }
    var maxLength = value.length - (separator.length + omission.length);
    var _c = __read(value.split(separator)), firstWord = _c[0], words = _c.slice(1);
    if (firstWord.length > maxLength) {
        return firstWord.substr(0, length - omission.length) + omission;
    }
    var result = [firstWord];
    var accLength = 0;
    try {
        for (var words_1 = __values(words), words_1_1 = words_1.next(); !words_1_1.done; words_1_1 = words_1.next()) {
            var word = words_1_1.value;
            accLength += word.length + separator.length;
            if (accLength > maxLength) {
                break;
            }
            result.push(word);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (words_1_1 && !words_1_1.done && (_a = words_1.return)) _a.call(words_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result.join(separator) + separator + omission;
}; };
exports.truncate = truncate;
//# sourceMappingURL=truncate.js.map